import AbstractService from '@/api/services/AbstractService';

class SettingsService extends AbstractService {
  public async all() {
    return this.request('get', this.buildPath('settings'));
  }
}

export default new SettingsService();
